export default "__VITE_ASSET__mcWLTCL7__"